export default "__VITE_ASSET__67d9117c__"